/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { PREBOOKED_TO_ACTUAL } from "../graphql";

const is = require("is_js");
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ISendRemainderMethods extends IPluginMethodMap {
  sendRemainder(args: any): Promise<any>;
}

export class SendRemainderService implements IAgentPlugin {
  readonly methods: ISendRemainderMethods;

  constructor() {
    this.methods = {
      sendRemainder: this.sendRemainder.bind(this),
    };
  }

  async sendRemainder(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log(args);
    try {
      if (client) {
        const res = await client.query({
          query: PREBOOKED_TO_ACTUAL,
          variables: {
            presentation: args?.presentation,
            filter: {
              _committee___email: {
                eq: args?.email,
              },
            },
          },
          fetchPolicy: "network-only",
        });

        if (res?.data?.getConvertedPreBookBoxes?.content) {
          let _rowData = this.formatTable(
            res?.data?.getConvertedPreBookBoxes?.content
          );
          console.log(_rowData);
          return {
            ultUsers: _rowData,
          };
        }
        return [];
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
  private formatTable(users: any[]): any {
    let _rowData: any = [];
    users?.forEach((data?: any) => {
      _rowData.push({
        name:
          data?.firstName && data?.lastName
            ? `${data.firstName} ${data.lastName}`
            : data?.firstName ?? data?.lastName ?? "Null",
        email: data?.email ?? "-",
        prebookedCostumeID: data?.prebookedCostumeID,
        actualCostumeID: data?.actualCostumeID,
        userId: data?.user_id,
        id: data?.actualBox_id,
      });
    });
    return _rowData;
  }
}
